import moment from 'moment';

export const DEFAULT_START_AT = moment
  .utc()
  .subtract(3, 'days')
  .format('YYYY-MM-DDT00:00:00.000');

export const DEFAULT_START_AT_30_DAYS = moment
  .utc()
  .subtract(30, 'days')
  .format('YYYY-MM-DDT00:00:00.000');

export const DEFAULT_END_AT = moment.utc().format('YYYY-MM-DDT23:59:59.999');
